import { Box, Text } from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'

export const StyledIntroBox = styled(Box)`
  ${s({
    mt: 2,
    mb: 8,
  })}

  text-align: center;
`

export const StyledIntroGreeting = styled(Text)`
  ${s({
    typography: 'typeDisplay03',
    color: 'colorTextHeadline',
    mb: 3,
  })}
`

export const StyledIntroText = styled(Text)<{ $hasFirstName?: boolean }>`
  ${s({
    color: 'colorTextHeadline',
    mb: 3,
  })}

  ${({ $hasFirstName }) =>
    s({
      typography: $hasFirstName ? 'typeDisplay04' : 'typeDisplay03',
    })}
`
